<nav class="tabs">
  <ul class="tab-list">
    @for (tab of tabs; track tab.key) {
      <button [ngClass]="{ active: tab.key === activeTab }" (click)="tabChange.emit(tab.key)">
        {{ tab.label | translate }}{{ tab.suffix || '' }}
      </button>
    }
  </ul>
</nav>
